export const UPDATE_CAM_ACTION_TYPE = 'UPDATE_CAM_ACTION_TYPE' as const;
export const UPDATE_SELECTED_INDEX_ACTION_TYPE =
  'UPDATE_SELECTED_INDEX_ACTION_TYPE' as const;
